import { TITLE_DATA_SUCCESS, CLEAR_TITLE_DATA } from '../actions/titleActions';
import {
  TIMELINE_SET_ERA,
  TIMELINE_SET_SLIDE,
  TIMELINE_CONTROLLER_NAVIGATE,
} from '../actions/timelineTitleActions';


export const titles = (state = {}, action) => {
  switch (action.type) {
    case CLEAR_TITLE_DATA: {
      const uid = action.payload;
      const { [uid]: toDelete, ...rest } = state;
      return rest;
    }
    case TIMELINE_SET_ERA: {
      const { uid, slug } = action.payload;
      const newState = { ...state };
      newState[uid].activeEra = slug;
      newState[uid].slideData = newState[uid].erasBySlug[slug];
      return newState;
    }
    case TIMELINE_SET_SLIDE: {
      const { uid, index } = action.payload;
      const newState = { ...state };
      newState[uid].activeSlideIndex = index;
      return newState;
    }
    case TIMELINE_CONTROLLER_NAVIGATE: {
      const { uid, date } = action.payload;
      const newState = { ...state };
      newState[uid].controllerDate = date;
      return newState;
    }
    case TITLE_DATA_SUCCESS: {
      const { uid, ...rest } = action.payload;
      return {
        ...state,
        [uid]: { ...rest },
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/titleReducer.js